import React from 'react';
import TextareaCounter from 'components/InputCounter/InputCounter';
import { IoMdSync } from 'react-icons/io';

const FreeText = ({
  test,
  question,
  setQuestionArray,
  questionArray,
  handleOnchange,
  isSync,
}) => (
  <div>
    <TextareaCounter
      rows="5"
      // max={500}
      id="freeText"
      test={test}
      question={question}
      setQuestionArray={setQuestionArray}
      questionArray={questionArray}
      handleOnchange={handleOnchange}
    />
    {/*     
      <p style={{ color: '#000000d9' }} >
         <IoMdSync className={isSync ? 'spinner' : ''} size={18}/> Auto Save
      </p> */}
  </div>
);

export default FreeText;
